'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _handleActions;

import * as ActionTypes from '../actions/ActionTypes';
import { handleActions, combineActions } from 'flux-actions';
var initialState = null;
export default handleActions((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.SET_CONSENT_RESPONSES, function (state, action) {
  return action.payload;
}), _defineProperty(_handleActions, combineActions(ActionTypes.RESET_CONSENT_RESPONSES, ActionTypes.BOOKING_TIME_CONFLICT), function () {
  return initialState;
}), _handleActions), initialState);